import React, { useState } from 'react';
import styled from 'styled-components';

interface CryptoChartProps {
  symbol: string;
  onClose: () => void;
}

const CryptoChart: React.FC<CryptoChartProps> = ({ symbol, onClose }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // TradingView widget URL'sini oluştur
  const getWidgetUrl = () => {
    const params = {
      symbol: `BINANCE:${symbol}USDT`,
      interval: 'D',
      theme: 'dark',
      style: '1', // Gelişmiş stil
      locale: 'tr_TR',
      toolbar_bg: '#f1f3f6',
      enable_publishing: true,
      withdateranges: true,
      hide_side_toolbar: false,
      allow_symbol_change: true,
      details: true,
      hotlist: true,
      calendar: true,
      studies: [
        'MASimple@tv-basicstudies',
        'RSI@tv-basicstudies',
        'MACD@tv-basicstudies'
      ],
      show_popup_button: true,
      popup_width: '1000',
      popup_height: '650',
      container_id: 'tradingview_widget',
      // Çizim araçları ve özellikler
      drawings: true,
      drawingToolbars: true,
      enableDrawing: true,
      saveDrawings: true,
      showDrawings: true,
      // Ek özellikler
      news: true,
      alerts: true,
      trades: true,
      orderBook: true,
      volume_force_overlay: true,
      // Gelişmiş özellikler
      publishBtn: true,
      saveChartBtn: true,
      chartToolbar: true,
      timeFrames: true,
      studyTemplates: true
    };

    const queryString = Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return `https://s.tradingview.com/widgetembed/?${queryString}`;
  };

  return (
    <ChartOverlay>
      <ChartContainer $isFullscreen={isFullscreen}>
        <ChartHeader>
          <HeaderLeft>
            <ChartTitle>{symbol}/USDT Grafiği</ChartTitle>
            <ChartControls>
              <ControlButton 
                onClick={() => setIsFullscreen(!isFullscreen)}
                title={isFullscreen ? 'Küçült' : 'Tam Ekran'}
              >
                {isFullscreen ? '⊙' : '⤢'}
              </ControlButton>
            </ChartControls>
          </HeaderLeft>
          <CloseButton onClick={onClose} title="Kapat">
            ✖
          </CloseButton>
        </ChartHeader>
        
        <ChartContent>
          <TradingViewWidget
            src={getWidgetUrl()}
            allow="fullscreen"
            allowTransparency={true}
          />
        </ChartContent>
      </ChartContainer>
    </ChartOverlay>
  );
};

const ChartOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ChartContainer = styled.div<{ $isFullscreen: boolean }>`
  background: #1a1a1a;
  border-radius: ${props => props.$isFullscreen ? '0' : '12px'};
  width: ${props => props.$isFullscreen ? '100%' : '90%'};
  height: ${props => props.$isFullscreen ? '100%' : '90%'};
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  transition: all 0.3s ease;
  margin: ${props => props.$isFullscreen ? '0' : '20px'};
`;

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.2);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ChartTitle = styled.h2`
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
`;

const ChartControls = styled.div`
  display: flex;
  gap: 8px;
`;

const ControlButton = styled.button`
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
`;

const CloseButton = styled(ControlButton)`
  &:hover {
    color: #EF4444;
    background: rgba(239, 68, 68, 0.1);
  }
`;

const ChartContent = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;
`;

const TradingViewWidget = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export default CryptoChart;